import './LoadingIndicator.style.less'
import lottie from 'lottie-web'
import loadingFile from '@/assets/lottie/data.json'
import { useEffect } from 'react'

interface Props {
  loading: boolean
}

function LoadingIndicator({ loading }: Props) {
  useEffect(() => {
    lottie.loadAnimation({
      container: document.querySelector('#react-logo') as any,
      animationData: loadingFile,
      renderer: 'svg', // "canvas", "html"
      loop: true, // boolean
      autoplay: true, // boolean
    })
  }, [])

  if (loading)
    return (
      <div className="loading">
        <div id="react-logo" style={{ width: 50, height: 50 }} />
      </div>
    )
  return <div />
}

export default LoadingIndicator
